import { Link, useMatchRoute } from "@tanstack/react-router";
import { cn } from "@/lib/utils";

const tabs = [
  { to: "/warehouse/scan" as const, label: "Skeniranje" },
  { to: "/warehouse/locations" as const, label: "Pregled" },
  { to: "/warehouse/move" as const, label: "Premještanje" },
];

export function WarehouseNav() {
  const matchRoute = useMatchRoute();

  return (
    <div className="flex gap-0 px-4 pt-3 border-b border-foreground/10">
      {tabs.map((tab) => {
        const isActive = matchRoute({ to: tab.to });
        return (
          <Link
            key={tab.to}
            to={tab.to}
            className={cn(
              "shrink-0 px-3 pb-2 pt-0.5 text-xs font-medium transition-colors relative",
              "hover:text-foreground",
              isActive ? "text-foreground" : "text-muted-foreground"
            )}
          >
            {tab.label}
            {isActive && (
              <span className="absolute bottom-0 left-3 right-3 h-px bg-foreground" />
            )}
          </Link>
        );
      })}
    </div>
  );
}
